"use strict";

require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _constellation = require("@zillow/constellation");
var S = _interopRequireWildcard(require("./styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } // Constellation
// Misc / Utils
// To workaround a @zillow-types/constellation issue, where children is required in FormField
var Empty = function Empty() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
};
var Form = function Form(_ref) {
  var tenantStatuses = _ref.tenantStatuses,
    setTenantStatus = _ref.setTenantStatus,
    setMonthlyRent = _ref.setMonthlyRent,
    setMoveDate = _ref.setMoveDate,
    handleCalculateButtonClick = _ref.handleCalculateButtonClick,
    errors = _ref.errors;
  var handleChangeTenantStatus = function handleChangeTenantStatus(e) {
    return setTenantStatus(e.target.value);
  };
  // Necessary because the type of DatePickerInputProps['onChange'] resolves to:
  // ((event: React.ChangeEvent<HTMLInputElement) => void) & ((value: string) => void)
  // AKA Function Overload: https://www.typescriptlang.org/docs/handbook/functions.html#overloads
  var handleChangeMoveDate = function handleChangeMoveDate(e) {
    if (_typeof(e) === 'object') {
      setMoveDate(e.target.value);
    } else if (typeof e === 'string') {
      setMoveDate(e);
    }
  };
  var handleChangeRent = function handleChangeRent(e) {
    return setMonthlyRent(e.target.value);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_constellation.Form, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.FormField, {
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Label, {
        children: "Select tenant status"
      }),
      control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Select, {
        onChange: handleChangeTenantStatus,
        children: tenantStatuses.map(function (status) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
            children: status
          }, status);
        })
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Empty, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.FormField, {
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Label, {
        children: "Enter monthly rent"
      }),
      control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.AdornedInput, {
        input: /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Input, {
          placeholder: "Enter monthly rent amount",
          onChange: handleChangeRent
        }),
        leftAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Adornment, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Text, {
            children: "$"
          })
        })
      }),
      error: !!errors.monthlyRent,
      description: errors.monthlyRent && /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.FormHelp, {
        children: errors.monthlyRent
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Empty, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.FormField, {
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Label, {
        children: "Enter tenant move date"
      }),
      control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.AdornedInput, {
        input: /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.DatePickerInput, {
          placeholder: "Select date",
          onChange: handleChangeMoveDate
        }),
        rightAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Adornment, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.IconCalendarOutline, {
            fontColor: "brand"
          })
        })
      }),
      error: !!errors.moveDate,
      description: errors.moveDate && /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.FormHelp, {
        children: errors.moveDate
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Empty, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.FormActions, {
      as: _constellation.ButtonGroup,
      "aria-label": "Calculate",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(S.CenterButton, {
        buttonType: "primary",
        onClick: function onClick(e) {
          e.preventDefault();
          handleCalculateButtonClick();
        },
        fluid: true,
        children: "Calculate"
      })
    })]
  });
};
var _default = exports["default"] = Form;